import request from '@/utils/request'


// 查询机构评级列表
export function listGrade(query) {
  return request({
    url: '/grade/grade/list',
    method: 'get',
    params: query
  })
}

// 查询机构评级分页
export function pageGrade(query) {
  return request({
    url: '/grade/grade/page',
    method: 'get',
    params: query
  })
}

// 查询机构评级详细
export function getGrade(data) {
  return request({
    url: '/grade/grade/detail',
    method: 'get',
    params: data
  })
}

// 新增机构评级
export function addGrade(data) {
  return request({
    url: '/grade/grade/add',
    method: 'post',
    data: data
  })
}

// 修改机构评级
export function updateGrade(data) {
  return request({
    url: '/grade/grade/edit',
    method: 'post',
    data: data
  })
}

// 删除机构评级
export function delGrade(data) {
  return request({
    url: '/grade/grade/delete',
    method: 'post',
    data: data
  })
}
